import { render, staticRenderFns } from "./ModalSelectGrade.vue?vue&type=template&id=d3e13cca&scoped=true&lang=pug&"
import script from "./ModalSelectGrade.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectGrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e13cca",
  null
  
)

export default component.exports